import { createSelector } from 'reselect';

const selectDealerLogin = ({ dealerLogin }) => dealerLogin;

export const selectUserLoggedIn = createSelector(
  [selectDealerLogin],
  ({ userLoggedIn = false }) => userLoggedIn
);
